/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTableComponent } from "../../../shared/components/data-table/data-table.component";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { DeleteModalComponent } from "../../../shared/components/delete-modal/delete-modal.component";
import { UserInfo } from "../../../shared/types/user-info";
import { Ticket } from "./ticket.type";
import { TicketTableService } from "./ticket-table.service";

@Component({
  selector: "app-tickets",
  templateUrl: "./tickets.component.html",
  styleUrls: ["./tickets.component.scss"],
})
export class TicketsComponent implements OnInit {
  @ViewChild(DataTableComponent) dataTableComponent: DataTableComponent<Ticket>;
  currentUser: UserInfo;
  ticketTableConfig: DataTable<Ticket>;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DeleteModalComponent>,
    public ticketTableService: TicketTableService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Life cycle method

  ngOnInit(): void {
    this.ticketTableConfig = this.ticketTableService.getTicketsTableConfig();
  }

  // #endregion
}
